import { render } from "./StudentMyCourses.vue?vue&type=template&id=1fb1f337&scoped=true"
import script from "./StudentMyCourses.vue?vue&type=script&lang=js"
export * from "./StudentMyCourses.vue?vue&type=script&lang=js"

import "./StudentMyCourses.vue?vue&type=style&index=0&id=1fb1f337&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb1f337"]])

export default __exports__